module.exports = (__webpack_require__(19584))(6710);